<div class="layout-content">
  <sub-header>
    <ces-breadcrumb
      [menuItems]="preferenceBreadcrumbs"
      variation="design"
    ></ces-breadcrumb>
  </sub-header>

  <ces-card
    style="height: calc(100vh - 160px); overflow-y: hidden"
    class="card-job-list"
  >
    <ces-card-header>
      <div class="header-grid-container d-none">
        <div class="textbx">
          <ces-textbox
            inputType="text"
            iconPosition="left"
            placeholder="Search user here..."
            icon="icon-search"
            [clearText]="false"
          ></ces-textbox>
        </div>
      </div>
    </ces-card-header>
    <ces-card-body>
      <div class="security-container">
        <div class="primary-mode-block">
          <div class="primary-mode-title mb-24">
            <span>Multi-Factor Authentication</span>
          </div>
          <div class="guardian-block mb-24">
            <div class="policy-desc-action">
              <div class="sec-description">
                Define when users will be able to authenticate using an additional factor for all
                Applications
              </div>
              <div class="sec-action">
                <div class="policy-rows">
                  <div
                    class="policy-block"
                    (click)="requireAuthClick(null)"
                    [ngClass]="{ selected: selectedMfaAuthType == 'none' }"
                  >
                    <div class="security-label">
                      Never
                      <div
                        class="policy-tick-mark"
                        *ngIf="selectedMfaAuthType == 'none'"
                      >
                        <i class="icon icon-success"></i>
                      </div>
                    </div>
                    <div class="security-desc-action">
                      <div class="sec-description">
                        Users are not required to use an additional factor to login
                      </div>
                    </div>
                  </div>

                  <div
                    class="policy-block"
                    (click)="requireAuthClick('confidence-score')"
                    [ngClass]="{ selected: selectedMfaAuthType == 'confidence-score' }"
                  >
                    <div class="security-label">
                      Use adaptive MFA
                      <div
                        class="policy-tick-mark"
                        *ngIf="selectedMfaAuthType == 'confidence-score'"
                      >
                        <i class="icon icon-success"></i>
                      </div>
                    </div>
                    <div class="security-desc-action">
                      <div class="sec-description">
                        Users are required to have an additional factor if the login appears to be a
                        high risk.
                      </div>
                    </div>
                  </div>

                  <div
                    class="policy-block"
                    (click)="requireAuthClick('all-applications')"
                    [ngClass]="{ selected: selectedMfaAuthType == 'all-applications' }"
                  >
                    <div class="security-label">
                      Always
                      <div
                        class="policy-tick-mark"
                        *ngIf="selectedMfaAuthType == 'all-applications'"
                      >
                        <i class="icon icon-success"></i>
                      </div>
                    </div>
                    <div class="security-desc-action">
                      <div class="sec-description">
                        Users are always required to use an additional factor to log in.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="primary-mode-block">
          <div class="primary-mode-title mb-24">MFA Factors</div>
          <div class="guardian-block mb-24">
            <div class="security-label">Auth0 Guardian</div>
            <div class="security-desc-action">
              <div class="sec-description">
                Auth0 Guardian is a mobile app that can deliver push notifications to a user’s
                pre-registered device (typically a mobile phone or tablet) from which a user can
                immediately allow or deny account access via the press of a button. It can also
                generate one-time passwords if that factor is preferred. Instead of integrating with
                each vendor-specific push notification service.
              </div>
              <div class="sec-action">
                <ces-switch
                  [(ngModel)]="guardianPushNotificationEnable"
                  name="isActive"
                  (onChange)="onActionClick('push-notification', $event)"
                ></ces-switch>
              </div>
            </div>
          </div>
          <div class="guardian-block mb-24">
            <div class="security-label">Authenticator</div>
            <div class="security-desc-action">
              <div class="sec-description">
                It generates a one-time password using a shared secret key and the current time.
                These passwords are short-lived (between 30 to 60 seconds), and require that the
                server and device clocks to be synchronized. For example, Google Authenticator.
              </div>
              <div class="sec-action">
                <ces-switch
                  [(ngModel)]="authenticatorOtpEnable"
                  name="isActive"
                  (onChange)="onActionClick('otp', $event)"
                ></ces-switch>
              </div>
            </div>
          </div>
          <div class="guardian-block mb-24">
            <div class="security-label">Email</div>
            <div class="security-desc-action">
              <div class="sec-description">
                Users will receive an email message containing a verification code.
              </div>
              <div class="sec-action">
                <ces-switch
                  [(ngModel)]="emailEnable"
                  name="isActive"
                  (onChange)="onActionClick('email', $event)"
                ></ces-switch>
              </div>
            </div>
          </div>
          <div class="guardian-block mb-24">
            <div class="security-label">SMS</div>
            <div class="security-desc-action">
              <div class="sec-description">
                This method uses one thing that the user always carries with himself, his mobile
                phone. Therefore, when the user attempt to log in, an SMS will be sent to the
                registered phone number with a one-time code that will be used to validate his
                identity.
              </div>
              <div class="sec-action">
                <ces-switch
                  [(ngModel)]="smsEnable"
                  name="isActive"
                  (onChange)="onActionClick('sms', $event)"
                ></ces-switch>
              </div>
            </div>
          </div>
          <div class="guardian-block mb-24">
            <div class="security-label">Recovery Code</div>
            <div class="security-desc-action">
              <div class="sec-description">
                A recovery code is a unique code, generated by Auth0, allowing a user to regain
                account access. So if a user cannot access the device or account used for
                multi-factor authentication (MFA) enrollment, they can use a recovery code to
                authenticate
              </div>
              <div class="sec-action">
                <ces-switch
                  [(ngModel)]="recoveryCodeEnable"
                  name="isActive"
                  (onChange)="onActionClick('recovery-code', $event)"
                ></ces-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="widget-loader"
        *ngIf="loader"
      >
        <ces-loaders
          type="spinner"
          size="medium"
          textPosition="center"
        ></ces-loaders>
      </div>
    </ces-card-body>
    <div #container></div>
  </ces-card>
</div>
